export const resources = {
  HeaderUserImageAlt: 'User Image'
};
